<template>
    <div class="footerB" :style="{ backgroundColor: props.backgroundColor }">
        <div class="footerB-inner-pannel-l">
            <div :style="{ color: Color }">
                <span >© 2025 </span>
                <span v-if="footerBGs.length > 0" 
                    @click="toHref(footerBGs[0].url, '_blank',footerBGs[0].certificationType,footerBGs[0])" 
                     :class="[handleCss(footerBGs[0].certificationType,footerBGs[0])]">
                    <img v-if="footerBGs[0].iconUrl" :src="commenUrl+footerBGs[0].iconUrl" >
                    {{ footerBGs[0].name }}
                </span>
                <span v-for="(footerBZzLi, footerBZzIndex) in footerBZz" :key="footerBZz.id"
                    @click="toHref(footerBZzLi.url, '_blank',footerBZzLi.certificationType,footerBZzLi)" :class="[handleCss(footerBZzLi.certificationType,footerBZzLi)]">
                    <img v-if="footerBZzLi.iconUrl" :src="commenUrl+footerBZzLi.iconUrl" >
                    {{ footerBZzLi.name }}
                </span>
            </div>
            <div>
                <span v-for="(footerBGsLi, footerBGsIndex) in footerBGs.slice(1)" :key="footerBZz.id"
                    @click="toHref(footerBGsLi.url, '_blank',footerBGsLi.certificationType,footerBGsLi)" :class="[handleCss(footerBGsLi.certificationType,footerBGsLi)]">
                    <img v-if="footerBGsLi.iconUrl" :src="commenUrl+footerBGsLi.iconUrl" >
                    {{ footerBGsLi.name }}
                </span>
                <span v-if="platInfo.tel">
                    客服热线：{{platInfo.tel}}
                </span>
            </div>
        </div>
        <div class="footerB-inner-pannel-r">
            <div @click="toHref('legaNotice', '_blank')" :class="[`wui-hover-color-${themeColor}`]">
                法律声明
            </div>
            <div @click="toHref('privacyPolicy', '_blank')" :class="[`wui-hover-color-${themeColor}`]">
                隐私政策声明
            </div>
        </div>
        <el-image-viewer
            v-if="showPreview"
            :url-list="srcList"
            show-progress
            :initial-index="0"
            @close="showPreview = false"
        />
    </div>
</template>
<script setup>
import { ref, defineProps, defineEmits, onMounted, onUnmounted, watch, nextTick, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
const props = defineProps({
    backgroundColor: {
        type: String,
        default: 'transparent'
    },
    themeColor: {
        type: String,
        default: 'blue'
    },
        Color: {
        type: String,
        default: '#2E2F2F'
    },
    platInfo: {
        type: Object,
        default: {}
    }
})
const { proxy } = getCurrentInstance();
const footerBZz = ref([])
const footerBGs = ref([])
const router = useRouter();
const getSwzz = (t) => {
    proxy.$request({
        url: "PROTAL_N_INDUSTRYCERTIFICATION_FINDLIST_TYPE",
        method: "post",
        data: { "showType": "0", "portalType": proxy.getConfig().portalType, "type": t }
    }).then((res) => {
        if (res.data.code == "000") {
            if (t == '0') {
                footerBZz.value = res.data.result
            } else {
                footerBGs.value = res.data.result
            }
        }
    }).catch((err) => {
        console.log(err)
    });
}
onMounted(async () => {
    getSwzz('0')
    getSwzz('1')
});
// 跳转
// 判断是否为完整URL
const isFullUrl = (url) => {
    return /^https?:\/\//.test(url);
};

// 执行跳转
const showPreview = ref(false);

const srcList = ref([]);
const toHref = (url, type) => {
    if (!url) {
        return;
    }
    if (type === '_blank' || type == '1') {
        // 新标签页打开
        proxy.tool.openWindow(url);
    } else if (isFullUrl(url)) {
        // 完整URL，使用页面跳转
        window.location.href = url;
    } else {
        // 相对路径，使用路由跳转
        router.push(url);
        navMenu.value = false;
    }
};
const handleCss = (toType,e)=>{
    let t = false
    if(toType=='0'||!toType){
        if (!e.url) {
            return;
        }
        t = true
    }else if(toType=='1'){
        let fileUrl = e.fileUrl
        if(fileUrl)t = true
    }else if(toType=='2'){
        let fileUrl = e.imgUrl
        if(fileUrl)t = true
    }
    return t?`wui-hover-color-${props.themeColor} cursor-pointer`:''
}
</script>
<style scoped lang="less">
.footerB {
    width: 100%;
    display: flex;
    .footerB-inner-pannel-l{
        flex: 1;
        font-size: 13px;
        span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            // color: #2E2F2F;
            line-height: 24px;
            margin-right: 20px;
            align-items: center;
        }
        img{
            width: 16px;
            height: 16px;
            margin-right:4px;
        }
    }
    .footerB-inner-pannel-r{
        width: 136px;
        height: 17px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        // color: #191919;
        line-height: 17px;
        text-align: left;
        font-style: normal;
        display: flex;
        justify-content: space-between;
        div{
            cursor: pointer;
        }
    }
    .cursor-pointer{
        cursor: pointer;
    }
}
</style>
